import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Output,
  QueryList,
} from '@angular/core';
import { TabComponent } from './tab/tab.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent> =
    new QueryList();
  @Output() activeTabChange = new EventEmitter<number>();
  activeTabIndex = 0;

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

  }

  ngAfterContentInit() {
    this.selectTab(this.activeTabIndex);
  }

  selectTab(index: number) {
    this.activeTabIndex = index;

    // Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.tabs.toArray().forEach((tab, i) => (tab.active = i === index));
      this.activeTabChange.emit(this.activeTabIndex);
      this.cdr.detectChanges(); // Ensures Angular is aware of the changes
    });
  }
}
